import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["formSection"]

  showForm() {
    this.formSectionTarget.classList.remove("hidden")
    this.formSectionTarget.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
